var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scroll-bar',[_c('el-menu',{staticStyle:{"padding-bottom":"50px"},attrs:{"mode":"vertical","show-timeout":200,"default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":"#304156","text-color":"#bfcbd9","active-text-color":"#409EFF"}},[_c('sidebar-item',{attrs:{"routes":_vm.routes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/layout/components/Sidebar/index.vue?vue&type=template&id=46a319da&
// module id = null
// module chunks = 